import * as React from 'react';
import { connect } from 'react-redux';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import '../ThirdPartyVendors/assets/vendorContract.css';
import { IVendors, IAgencies } from './business-objects/common';
import { GetURIByParts } from '../../services/Utils/StringUtils';
import { saveUpdatedAgencies } from './redux-objects/actions';
import VendorTabContainer from './VendorTabContainer';
import { Button, Modal, Form, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import SelectList from '../RBSelectList/RBSelectList';
import { UserInfo } from '../Login/common/defaults';
import CommentModal from '../CommentModal/CommentModal';
import { addVendorLog } from './logging/auditLog';

interface IAgencyVendorContractActionsFromProps {
  saveUpdatedAgencies: (
    url: string,
    vendorKeyId: number,
    selectedAgencies: number[]
  ) => Promise<void>;
}

interface IAgencyVendorContractStateFromProps {
  webServiceURL: string;
  vendors: IVendors[];
  agencies: IAgencies[];
  currentUser: UserInfo;
  elasticSearchURL: string;
}

interface IAgencyVendorContractLocalState {
  open: boolean;
  selected: number[];
  selectedVendor: IVendors;
  selectedVendorId: string;
  agenciesToUpdate: IAgencies;
  allAgencies: IAgencies[];
  pendingAction: string;
  showCommentModal: boolean;
  comment: string;
}

type IAgencyVendorContract = IAgencyVendorContractActionsFromProps &
  IAgencyVendorContractStateFromProps;

enum ServiceEndPoints {
  UpdateAgency = 'UpdateAgencyVendorBinding'
}

class AgencyVendorContract extends React.Component<
  IAgencyVendorContract,
  IAgencyVendorContractLocalState
> {
  private vendorServiceController: string = 'Vendor';

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selected: [],
      agenciesToUpdate: null,
      selectedVendor: null,
      showCommentModal: false,
      allAgencies: this.props.agencies,
      comment: '',
      pendingAction: '',
      selectedVendorId: '-1'
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.setState({ selectedVendor: this.props.vendors[0] });
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  container: any = React.createRef();

  handleGenericChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    switch (el.dataset.field) {
      case 'comment':
        this.setState({
          comment: el.value
        });
        break;
      default:
        break;
    }
  };

  handleChange = (changed: React.ChangeEvent<HTMLSelectElement>) => {
    let selectedVendor = this.props.vendors.find(
      vendor => vendor.id == parseInt(changed.currentTarget.value)
    );
    this.setState({
      selectedVendorId: changed.currentTarget.value,
      selectedVendor: selectedVendor,
      selected: this.state.allAgencies
        .filter(agency => agency.vendorId == selectedVendor.id.toString())
        .map(filteredAgencies => filteredAgencies.id)
    });
    
  };

  handleClickOutside = event => {
    if (
      this.container.current &&
      !this.container.current.contains(event.target)
    ) {
      this.setState({
        open: false
      });
    }
  };

  onChange = selected => {
    this.setState({ selected }, () =>
      console.log('Selected state: ' + this.state.selected)
    );
  };

  onSaveAgencyVendorBinding = () => {
    this.setState({
      pendingAction: 'updateVendor',
      showCommentModal: true
    });
  };

  cancelComment = () => {
    this.setState({
      comment: '',
      showCommentModal: false
    });
  };

  saveComment = () => {
    if (this.state.pendingAction == 'updateVendor')
      this.doSaveAgencyVendorBinding();
  };

  doSaveAgencyVendorBinding = async () => {
    let selectedVendor = this.state.selectedVendor;
    let agenciesToUpdate = this.state.selected;
    this.props.saveUpdatedAgencies(
      GetURIByParts(
        this.props.webServiceURL,
        this.vendorServiceController,
        ServiceEndPoints.UpdateAgency
      ),
      selectedVendor.id,
      agenciesToUpdate
    ).then(res => {
      let updatedAgencies = this.state.allAgencies.map((agency) => {
        if (agenciesToUpdate.indexOf(agency.id) >= 0) 
          agency.vendorId = this.state.selectedVendor.id.toString();
        return agency;
      });

      this.setState({allAgencies: updatedAgencies});
      toast.success('Saved!');
    }).catch(ex => {
      console.error(ex);
      toast.error("Something went wrong. Please check console for details.")
    });
    //Audit Logging
    const action = 'Updated Agency-Vendor Binding';
    const desc = 'Updated ' + selectedVendor.name;
    const detailData = {
      vendor: selectedVendor,
      agencies: agenciesToUpdate
    };

    addVendorLog(
      this.props.elasticSearchURL,
      action,
      desc,
      this.props.currentUser.username,
      this.state.comment,
      detailData
    );

    this.setState({
      showCommentModal: false,
      pendingAction: ''
    });
  };

  componentDidUpdate() {
    if (this.state.allAgencies.length == 0 && this.props.agencies.length > 0) {
      this.setState({allAgencies: this.props.agencies});
    }
  }

  render() {
    const options = this.props.agencies.map(agency => {
      return { value: agency.id, label: agency.ori + ': ' + agency.name };
    });
    const { selected } = this.state;
    return (
      <div>
        <div className='grid-container'>
          <div className='vendor-list'>
            <Form>
              <Row>
                <Col>
                  {this.props.vendors && this.props.vendors.length > 0 && (
                    <Form.Group controlId='Name'>
                      <Form.Label>
                        <strong>Vendor List</strong>
                      </Form.Label>
                      <SelectList
                        className='w-25'
                        data={this.props.vendors.map((vendor, idx) => ({
                          name: vendor.name,
                          value: vendor.id
                        }))}
                        onChange={this.handleChange}
                        placeholder='Select Vendor'
                        value={this.state.selectedVendorId}
                      />
                    </Form.Group>
                  )}
                </Col>
              </Row>
            </Form>
            {this.state.selectedVendor && (
              <div id='listBox' className='listBox-container'>
                <div className='row'>
                  <div className='col-sm-6'>
                    &nbsp;&nbsp;&nbsp; Select Agency, then select the &gt; button
                    to add Vendor Key to Agency.{' '}
                  </div>
                  <div className='col-sm-6'>
                    &nbsp;&nbsp;&nbsp;
                    {this.state.selectedVendor &&
                      `${this.state.selectedVendor.name} Agencies`}
                  </div>
                </div>
                <div className='col-sm-12'>
                  <DualListBox
                    options={options}
                    selected={selected}
                    onChange={this.onChange}
                    defaultValue={this.state.selected}
                  />
                </div>
              </div>
            )}
            <div id='clear'> </div>
          </div>
        </div>
        <br></br>
        {this.state.selectedVendor && (
          <Button variant='success' onClick={this.onSaveAgencyVendorBinding}>
            Save Changes
          </Button>
        )}
        <CommentModal
          comment={this.state.comment}
          show={this.state.showCommentModal}
          onCommentChange={this.handleGenericChange}
          onCloseCommentModal={this.cancelComment}
          onCancel={this.cancelComment}
          onSave={this.saveComment}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {
  saveUpdatedAgencies
};

const mapStateToProps = (reduxState: any) => {
  return {
    vendors: reduxState.Vendors.allVendors,
    agencies: reduxState.Vendors.allAgencies,
    webServiceURL: reduxState.Application.backendURL,
    elasticSearchURL: reduxState.Application.elasticSearchURL,
    currentUser: reduxState.Application.currentUser
  };
};

export default connect<any>(
  mapStateToProps,
  mapDispatchToProps
)(AgencyVendorContract);
